import React, { useState } from "react";
import styles from "./UserTimeTracking.module.css";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import {
  Typography,
} from "@mui/material";
import TimeTracking from "./components/TimeTracking";
import Loader from "../../components/Loader";
import { withAuthenticationRequired } from "@auth0/auth0-react";


function UserTimeTracking() {


  return (
    <React.Fragment>
      <Helmet title="User Time Tracking" />
      

      <div className={`${styles.mainCard}`}>

        {/* <div className={`${styles.pageTitleWrap}`}>
          <Typography display="inline" className={`${styles.pageTitle}`}>
            User Time Tracking
          </Typography>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}>
                <span>
                  <Home />
                </span>
                Renewal Offers{" "}
              </li>
            </ol>
          </nav>
        </div> */}
        
        <div className={`${styles.CenterBlockSec}`}>
          <TimeTracking />
        </div>
      </div>


      <Footer />
    </React.Fragment>
  );
}


export default withAuthenticationRequired(UserTimeTracking, {
  onRedirecting: () => <Loader />,
});